import { c as _c } from "react/compiler-runtime";
import { useViewPort } from "@website/hooks/viewport";
import { MiniPopoverPropertiesType } from "@website/ui/mini-popover/mini-popover.types";
import { RefObject, useEffect, useState } from "react";
export const usePosition = (properties, popoverReference) => {
  const $ = _c(7);
  const {
    defaultHorizontalPosition
  } = properties;
  const {
    isMobile
  } = useViewPort();
  const [horizontalPosition, setHorizontalPosition] = useState(defaultHorizontalPosition || "start");
  let t0;
  let t1;
  if ($[0] !== horizontalPosition || $[1] !== isMobile || $[2] !== popoverReference) {
    t0 = () => {
      if (!isMobile && popoverReference.current) {
        let documentDirection = "ltr";
        if (document.documentElement) {
          documentDirection = document.documentElement.dir || "ltr";
        }
        const rect = popoverReference.current.getBoundingClientRect();
        if (documentDirection === "rtl") {
          if (horizontalPosition === "start") {
            if (rect.left < 0) {
              setHorizontalPosition("end");
            }
          } else {
            if (rect.right > window.innerWidth) {
              setHorizontalPosition("start");
            }
          }
        } else {
          if (horizontalPosition === "start") {
            if (rect.right > window.innerWidth) {
              setHorizontalPosition("end");
            }
          } else {
            if (rect.left < 0) {
              setHorizontalPosition("start");
            }
          }
        }
      }
    };
    t1 = [horizontalPosition, isMobile, popoverReference];
    $[0] = horizontalPosition;
    $[1] = isMobile;
    $[2] = popoverReference;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] !== horizontalPosition) {
    t2 = {
      horizontalPosition
    };
    $[5] = horizontalPosition;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};